// removed by extract-text-webpack-plugin
module.exports = {"nModal":"SimpleModal__nModal","nModalContent":"SimpleModal__nModalContent","nModalSm":"SimpleModal__nModalSm","nModalMd":"SimpleModal__nModalMd","nModalLg":"SimpleModal__nModalLg","nModalXLg":"SimpleModal__nModalXLg","nModalSt":"SimpleModal__nModalSt","nModalFs":"SimpleModal__nModalFs","nModalNormal":"SimpleModal__nModalNormal","nModalFull":"SimpleModal__nModalFull","nCloseButton":"SimpleModal__nCloseButton","nClose":"SimpleModal__nClose","nModalOverylayClose":"SimpleModal__nModalOverylayClose","nModalOverylayOpen":"SimpleModal__nModalOverylayOpen"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/SimpleModal/SimpleModal.scss
// module id = 660
// module chunks = 8